











import AppId from '@/util/appid'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class NavigationToPlanSelection extends Vue {
  get imageSrc(): string {
    return `/assets-proxy/images/${AppId.getHostName()}/paid-membership/navigation/to-plan-selection.png`
  }
}
